var _circle, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGsfBinIcon = function SvgGsfBinIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5,
    fill: "#fff",
    stroke: "#E8E9E9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "gsf-bin-icon_svg__a",
    width: 20,
    height: 20,
    x: 2,
    y: 2,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M2 2h20v20H2z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#gsf-bin-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#323941",
    d: "M8.09 19.082a1.45 1.45 0 0 1-1.064-.442 1.45 1.45 0 0 1-.443-1.064V6.999h-.208a.6.6 0 0 1-.445-.18.6.6 0 0 1-.18-.445q0-.266.18-.446t.445-.18H9.5a.7.7 0 0 1 .216-.52.7.7 0 0 1 .521-.216h3.526a.7.7 0 0 1 .521.215.7.7 0 0 1 .216.522h3.125q.266 0 .445.18.18.18.18.445 0 .266-.18.445a.6.6 0 0 1-.445.18h-.208v10.577q0 .621-.443 1.064a1.45 1.45 0 0 1-1.064.442zM16.167 7H7.833v10.577a.25.25 0 0 0 .072.184.25.25 0 0 0 .185.072h7.82a.25.25 0 0 0 .184-.072.25.25 0 0 0 .073-.184zm-5.705 9.167q.265 0 .445-.18t.18-.445V9.29a.6.6 0 0 0-.18-.446.6.6 0 0 0-.446-.18.6.6 0 0 0-.445.18.6.6 0 0 0-.18.446v6.25q0 .265.18.445t.446.18m3.077 0q.265 0 .445-.18t.18-.445V9.29a.6.6 0 0 0-.18-.446.6.6 0 0 0-.446-.18.6.6 0 0 0-.445.18.6.6 0 0 0-.18.446v6.25q0 .265.18.445t.446.18"
  }))));
};
export default SvgGsfBinIcon;